const currentDomain = window.location.hostname;

export const API_BASE_URL =
  currentDomain === "localhost" ||
    currentDomain === "127.0.0.1" ||
    currentDomain === "aiconnect.com.tr" ||
    currentDomain === "demo.aiconnect.com.tr"
    // ? "https://apis.aiconnect.com.tr"
    // ? "https://apis.santral.medium.com.tr"
    ? "https://apis.santral.medium.com.tr"
    : `https://apis.${currentDomain}`;

// otomatik arama için yapılan endpoint
export const API_BASE_URL2 = "https://apis.aiconnect.com.tr:3001";

export const API_BASE_URL_DEFERRED = `${API_BASE_URL}:5006`;

export const WHATSAPP_URL =
  currentDomain === "localhost" || currentDomain === "127.0.0.1"
    ? `https://wps.santral.medium.com.tr`
    : `https://wps.${currentDomain}`;

export const MULTIACC_URL =
  currentDomain === "localhost" || currentDomain === "127.0.0.1"
    ? `https://wpm.santral.medium.com.tr`
    : `https://wpm.${currentDomain}`;

export const MULTIACC_URL_OFFICIAL =
  currentDomain === "localhost" || currentDomain === "127.0.0.1"
    ? `https://wpm.official.santral.medium.com.tr`
    : `https://wpm.official.${currentDomain}`;

export const TELEGRAM_URL =
  currentDomain === "localhost" || currentDomain === "127.0.0.1"
    ? "https://tgs.aiconnect.com.tr:2055"
    : "https://tgs.aiconnect.com.tr:2055";

export const MULTIACCTG_URL =
  currentDomain === "localhost" || currentDomain === "127.0.0.1"
    ? "https://tgm.aiconnect.com.tr:2056"
    : "https://tgm.aiconnect.com.tr:2056";

/* Eğer domain aiconnect ise newFeature sabitini kullandığımız yerdeki özellikler gözükecek kaldırmak için newFeature sabitini kullanıldığı yerlerden sil bunun sebebi iki farklı domainde tek build çalıştırdığımızda demo aşamasındaki özelliklerinde her seferinde kapat aç işleminin önüne geçmek
 */

export const newFeature =
  currentDomain === "localhost" ||
    currentDomain === "127.0.0.1" ||
    currentDomain === "aiconnect.com.tr" ||
    currentDomain === "demo.aiconnect.com.tr"
    ? true
    : false;
